// istanbul ignore file

/**
 * Returns current window location pathname.
 * This is a convenience method to allow easier testing.
 */
export const getPathname = () => window.location.pathname;
